import React from "react";
import Dropdown from "components/dropdown";
import { Link, useLocation } from "react-router-dom";
import Logo from "assets/img/layout/logo.png";
import BBALogoMainnet from "assets/img/layout/bba-logo-mainnet.png";
import BrandText from "assets/img/layout/header.png";
import { FaAngleDown } from "react-icons/fa6";
import Switch from "react-switch";
import { MdLightMode, MdNightsStay } from "react-icons/md";
import { IoMdMenu } from "react-icons/io";
import Price from "./price";
import { RootState } from "reducers";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "store";
import { updateAppConfigRequest } from "actions";

const Header = (props: {
  onOpenSidenav: () => void;
  brandText: string;
  secondary?: boolean | string;
}) => {
  // const { onOpenSidenav, brandText } = props;
  const location = useLocation();

  const dispatch = useDispatch<AppDispatch>();
  const { config } = useSelector((state: RootState) => state.app);

  const toggleTheme = () => {
    dispatch(
      updateAppConfigRequest({
        ...config,
        theme: config?.theme === "dark" ? "light" : "dark",
      })
    );
  };

  return (
    <header className="fixed z-[9999] flex w-full flex-row flex-wrap items-center justify-between bg-gray-50 shadow-lg dark:bg-black">
      <div className="mx-auto w-full max-w-full px-2.5 md:px-3 lg:px-5 2xl:max-w-[1400px]">
        <div className="flex items-center justify-between gap-3 py-4">
          <div className="flex items-center gap-8">
            <Link
              to="/"
              className="flex items-center font-bold capitalize hover:text-navy-700 dark:hover:text-white"
            >
              <img
                width={37.4}
                height={37.4}
                className="mr-4 max-w-none"
                src={Logo}
                alt="Logo"
              />
              <img
                width={115.41}
                height={15.96}
                className="max-w-none"
                src={BrandText}
                alt="BrandText"
              />
            </Link>
            <Price />
          </div>
          <div className="flex flex-row flex-wrap items-center justify-start gap-1">
            <div
              role="menubar"
              className="hidden h-10 items-center p-1 2xl:flex"
              data-orientation="horizontal"
            >
              <Dropdown
                button={
                  <p
                    className={`text-medium ml-0 flex cursor-pointer select-none items-center rounded-sm px-2 py-1.5 outline-none xl:px-4 ${
                      location.pathname === "/accounts" ||
                      location.pathname === "/blocks" ||
                      location.pathname === "/txs"
                        ? "text-green-800"
                        : ""
                    }`}
                  >
                    Blockchain
                    <span className="ml-[1px] text-xs">
                      <FaAngleDown />
                    </span>
                  </p>
                }
                animation="origin-[30%_0%] md:origin-top-center transition-all duration-300 ease-in-out"
                children={
                  <div className="box grid grid-cols-1 rounded-[7px] bg-white py-2.5 dark:bg-darkGrey1">
                    <Link
                      className="text-xsmall mb-2.5 border-b-[1px] border-gray-100 px-[14px] py-1 hover:bg-gray-50 dark:border-lightGrey hover:dark:bg-darkGrey"
                      to="/accounts"
                    >
                      Accounts
                    </Link>
                    <Link
                      className="text-xsmall mb-2.5 border-b-[1px] border-gray-100 px-[14px] py-1 hover:bg-gray-50 dark:border-lightGrey hover:dark:bg-darkGrey"
                      to="/blocks"
                    >
                      Blocks
                    </Link>
                    <Link
                      className="text-xsmall mb-2.5 border-b-[1px] border-gray-100 px-[14px] py-1 hover:bg-gray-50 dark:border-lightGrey hover:dark:bg-darkGrey"
                      to="/txs"
                    >
                      Transactions
                    </Link>
                    <Link
                      to="#"
                      className="text-xsmall mb-2.5 border-b-[1px] border-gray-100 px-[14px] py-1 hover:bg-gray-50 dark:border-lightGrey hover:dark:bg-darkGrey"
                    >
                      Validators (Comming Soon)
                    </Link>
                  </div>
                }
                classNames={"w-[140px] mt-9"}
              />
              <Dropdown
                button={
                  <p
                    className={`text-medium ml-0 flex cursor-pointer select-none items-center rounded-sm px-2 py-1.5 outline-none xl:px-4 ${
                      location.pathname === "/tokens" ||
                      location.pathname === "/nfts"
                        ? "text-green-800"
                        : ""
                    }`}
                  >
                    Tokens
                    <span className="ml-[1px] text-xs">
                      <FaAngleDown />
                    </span>
                  </p>
                }
                animation="origin-[30%_0%] md:origin-top-center transition-all duration-300 ease-in-out"
                children={
                  <div className="box grid grid-cols-1 rounded-[7px] bg-white py-2.5 dark:bg-darkGrey1">
                    <Link
                      className="text-xsmall mb-2.5 border-b-[1px] border-gray-100 px-[14px] py-1 hover:bg-gray-50 dark:border-lightGrey hover:dark:bg-darkGrey"
                      to="/tokens"
                    >
                      Tokens
                    </Link>
                    <Link
                      className="text-xsmall mb-2.5 border-b-[1px] border-gray-100 px-[14px] py-1 hover:bg-gray-50 dark:border-lightGrey hover:dark:bg-darkGrey"
                      to="/nfts"
                    >
                      NFTs
                    </Link>
                  </div>
                }
                classNames={"w-[140px] mt-9"}
              />
              <Dropdown
                button={
                  <p
                    className={`text-medium ml-0 mr-6 flex cursor-pointer select-none items-center rounded-sm px-2 py-1.5 outline-none xl:px-4 ${
                      // location.pathname === "/accounts" ||
                      location.pathname === "/status" ? "text-green-800" : ""
                    }`}
                  >
                    Utilities
                    <span className="ml-[1px] text-xs">
                      <FaAngleDown />
                    </span>
                  </p>
                }
                animation="origin-[30%_0%] md:origin-top-center transition-all duration-300 ease-in-out"
                children={
                  <div className="box grid grid-cols-1 rounded-[7px] bg-white py-2.5 dark:bg-darkGrey1">
                    <Link
                      className="text-xsmall border-b-[1px] border-gray-100 px-[14px] py-1 hover:bg-gray-50 dark:border-lightGrey hover:dark:bg-darkGrey"
                      to="/status"
                    >
                      Network Status
                    </Link>
                  </div>
                }
                classNames={"w-[140px] mt-9"}
              />
              <Link to="/login" className="btn btn-xs mr-9 shadow-md">
                Sign in
              </Link>
              <Dropdown
                button={
                  <img
                    width={31}
                    height={31}
                    className="mr-9 cursor-pointer"
                    src={BBALogoMainnet}
                    alt="BBA Logo"
                  />
                }
                animation="origin-[0%_0%] md:origin-top-right transition-all duration-300 ease-in-out"
                children={
                  <div className="box grid grid-cols-1 rounded-[7px] bg-white py-2.5 dark:bg-darkGrey1">
                    <Link
                      className="text-xsmall mb-2.5 border-b-[1px] border-gray-100 px-[14px] py-1 hover:bg-gray-50 dark:border-lightGrey hover:dark:bg-darkGrey"
                      to="https://bbascan.com"
                    >
                      BBA Mainnet
                    </Link>
                    <Link
                      className="text-xsmall mb-2.5 border-b-[1px] border-gray-100 px-[14px] py-1 hover:bg-gray-50 dark:border-lightGrey hover:dark:bg-darkGrey"
                      to="https://testnet.bbascan.com"
                    >
                      BBA Testnet
                    </Link>
                  </div>
                }
                classNames={"w-[140px] mt-9"}
              />
              <Switch
                onChange={toggleTheme}
                checked={config?.theme === "dark"}
                className="react-switch shadow-md"
                width={65}
                height={31}
                offColor={config?.theme === "dark" ? "#404040" : "#efefef"}
                onColor={config?.theme === "dark" ? "#404040" : "#efefef"}
                offHandleColor="#FFF"
                onHandleColor="#14AE00"
                uncheckedIcon={<></>}
                checkedIcon={<></>}
                uncheckedHandleIcon={
                  <div className="flex h-full w-full items-center justify-center text-xl">
                    <MdLightMode />
                  </div>
                }
                checkedHandleIcon={
                  <div className="flex h-full w-full items-center justify-center text-xl text-white">
                    <MdNightsStay />
                  </div>
                }
              />
            </div>
          </div>
          <div className="flex items-center 2xl:hidden">
            <Link to="/login" className="btn btn-xs mr-3 shadow-md">
              Sign in
            </Link>
            <Switch
              onChange={toggleTheme}
              checked={config?.theme === "dark"}
              className="react-switch mr-3 shadow-md"
              width={46}
              height={22}
              offColor={config?.theme === "dark" ? "#404040" : "#efefef"}
              onColor={config?.theme === "dark" ? "#404040" : "#efefef"}
              offHandleColor="#FFF"
              onHandleColor="#14AE00"
              uncheckedIcon={<></>}
              checkedIcon={<></>}
              uncheckedHandleIcon={
                <div className="flex h-full w-full items-center justify-center text-lg">
                  <MdLightMode />
                </div>
              }
              checkedHandleIcon={
                <div className="flex h-full w-full items-center justify-center text-lg text-white">
                  <MdNightsStay />
                </div>
              }
            />
            <Dropdown
              button={
                <span className="text-xl">
                  <IoMdMenu />
                </span>
              }
              animation="cursor-pointer origin-[50%_0%] origin-top-center transition-all duration-300 ease-in-out ml-[2.125rem] md:ml-[2.25rem] lg:ml-[2.75rem]"
              children={
                <div className="box ml-[-100%] grid w-screen grid-cols-1 !rounded-[7px] bg-white py-2.5 dark:bg-darkGrey1 dark:text-gray-500">
                  <Link
                    className="text-xsmall mb-2.5 border-b-[1px] border-gray-100 px-[14px] py-1 hover:bg-gray-50 dark:border-lightGrey hover:dark:bg-darkGrey"
                    to="/"
                  >
                    Home
                  </Link>
                  <Link
                    className="text-xsmall mb-2.5 border-b-[1px] border-gray-100 px-[14px] py-1 hover:bg-gray-50 dark:border-lightGrey hover:dark:bg-darkGrey"
                    to="/txs"
                  >
                    Transactions
                  </Link>
                  <Link
                    className="text-xsmall mb-2.5 border-b-[1px] border-gray-100 px-[14px] py-1 hover:bg-gray-50 dark:border-lightGrey hover:dark:bg-darkGrey"
                    to="/blocks"
                  >
                    Blocks
                  </Link>
                  <div className="text-xsmall mb-2.5 border-b-[1px] border-gray-100 px-[14px] py-1 hover:bg-gray-50 dark:border-lightGrey hover:dark:bg-darkGrey">
                    <Dropdown
                      stopPropagate={true}
                      button={
                        <p className={`flex`}>
                          NFTs
                          <span className="ml-[1px] text-xs">
                            <FaAngleDown />
                          </span>
                        </p>
                      }
                      animation="origin-[50%_0%] ml-[-14px] origin-top-center transition-all duration-300 ease-in-out"
                      children={
                        <div className="box grid w-screen grid-cols-1 !rounded-b-[7px] !rounded-t-none bg-white pb-2.5 dark:bg-darkGrey1">
                          <Link
                            className="text-xsmall mb-2.5 mt-1 border-b-[1px] border-gray-100 px-[14px] py-1 hover:bg-gray-50 dark:border-lightGrey hover:dark:bg-darkGrey"
                            to="/nfts"
                          >
                            NFTs
                          </Link>
                          <Link
                            className="text-xsmall mb-2.5 border-b-[1px] border-gray-100 px-[14px] py-1 hover:bg-gray-50 dark:border-lightGrey hover:dark:bg-darkGrey"
                            to="/trades"
                          >
                            Latest Trades
                          </Link>
                          <Link
                            className="text-xsmall border-b-[1px] border-gray-100 px-[14px] py-1 hover:bg-gray-50 dark:border-lightGrey hover:dark:bg-darkGrey"
                            to="/transfers"
                          >
                            Latest Transfers
                          </Link>
                        </div>
                      }
                      classNames={"mt-[24px]"}
                    />
                  </div>
                  <div className="text-xsmall mb-2.5 border-b-[1px] border-gray-100 px-[14px] py-1 hover:bg-gray-50 dark:border-lightGrey hover:dark:bg-darkGrey">
                    <Dropdown
                      stopPropagate={true}
                      button={
                        <p className={`flex`}>
                          Leaderboard
                          <span className="ml-[1px] text-xs">
                            <FaAngleDown />
                          </span>
                        </p>
                      }
                      animation="origin-[50%_0%] ml-[-14px] origin-top-center transition-all duration-300 ease-in-out"
                      children={
                        <div className="box grid w-screen grid-cols-1 !rounded-b-[7px] !rounded-t-none bg-white pb-2.5 dark:bg-darkGrey1">
                          <Link
                            className="text-xsmall mb-2.5 mt-1 border-b-[1px] border-gray-100 px-[14px] py-1 hover:bg-gray-50 dark:border-lightGrey hover:dark:bg-darkGrey"
                            to="/tokens"
                          >
                            Tokens
                          </Link>
                          <Link
                            className="text-xsmall border-b-[1px] border-gray-100 px-[14px] py-1 hover:bg-gray-50 dark:border-lightGrey hover:dark:bg-darkGrey"
                            to="/accounts"
                          >
                            Accounts
                          </Link>
                        </div>
                      }
                      classNames={"mt-[24px]"}
                    />
                  </div>
                  <div className="text-xsmall border-b-[1px] border-gray-100 px-[14px] py-1 hover:bg-gray-50 dark:border-lightGrey hover:dark:bg-darkGrey">
                    <Dropdown
                      stopPropagate={true}
                      button={
                        <p className={`flex`}>
                          Utilities
                          <span className="ml-[1px] text-xs">
                            <FaAngleDown />
                          </span>
                        </p>
                      }
                      animation="origin-[50%_0%] ml-[-14px] origin-top-center transition-all duration-300 ease-in-out"
                      children={
                        <div className="box grid w-screen grid-cols-1 !rounded-b-[7px] !rounded-t-none bg-white pb-2.5 dark:bg-darkGrey1">
                          <Link
                            className="text-xsmall mb-2.5 mt-1 border-b-[1px] border-gray-100 px-[14px] py-1 hover:bg-gray-50 dark:border-lightGrey hover:dark:bg-darkGrey"
                            to="/accounts"
                          >
                            Account Balance
                          </Link>
                          <Link
                            className="text-xsmall border-b-[1px] border-gray-100 px-[14px] py-1 hover:bg-gray-50 dark:border-lightGrey hover:dark:bg-darkGrey"
                            to="/status"
                          >
                            Network Status
                          </Link>
                        </div>
                      }
                      classNames={"mt-[24px]"}
                    />
                  </div>
                </div>
              }
              classNames={"mt-12"}
            />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
